import React, {useEffect} from 'react';
import axios from "axios";
import struktur from '../assets/struktur.jpeg'
import FadeIn from "../components/FadeIn";
const qs = require("qs");

const PegawaiContent = () => {
    const [pemimpin, setPemimpin] = React.useState(null);
    const [pegawai, setpegawai] = React.useState([]);
    const [anggota, setAnggota] = React.useState([]);

    useEffect(() => {
        getPegawai().then((res) => {
            const response = res.data;
            let pegawaitemp = []
            let anggotatemp = []
            response.forEach((pegawai) => {
                if (pegawai.position === 'Inspektur') {
                    setPemimpin(pegawai)
                } else {
                    pegawaitemp.push(pegawai)
                }
            })
            setpegawai(pegawaitemp)
            setAnggota(response)
        })
    }, []);

    const getPegawai = () => {
        return new Promise(async (resolve, reject) => {
            const obj = {
                filter: {

                },
                // fields: "id,slug,title,description,image,createdAt",
                limit: 20,
                page: 1,
                sort: "-createdAt",
            }

            const stringQuery = qs.stringify(obj, {allowDots: true});

            await axios.get('/api/civil-servant?' + stringQuery).then((response) => {
                resolve(response.data);
            }).catch((error) => {
                reject(error);
            })
        })
    }
    return (
        <>
            <div className='flex flex-col items-center justify-center'>
                <section className="body-font mt-10">
                    <FadeIn delay={0.2} direction='left' fullWidth>
                        <div className="flex items-center justify-center mx-2 my-0">
                            <img src={`${struktur}`} className='desktop:w-1/2 phone:w-[100%]' alt='struktur'/>
                        </div>
                    </FadeIn>
                </section>

                <section className='body-font w-full'>
                    <div className='flex items-center justify-center m-10'>
                        <h1 className='text-2xl'>Data Pegawai Inspektorat</h1>
                    </div>
                    <div className="">
                        <div className="overflow-x-scroll overflow-x-visible desktop:my-10 desktop:mx-20 my-2 mx-4">
                            <table className="desktop:w-full phone:w-[500px] rounded bg-white border border-gray-200">
                                <thead className="bg-gray-100">
                                    <tr>
                                        <th className="py-2 px-4 border-b">Nama</th>
                                        <th className="py-2 px-4 border-b">Jabatan</th>
                                        <th className="py-2 px-4 border-b">NIP</th>
                                        <th className="py-2 px-4 border-b">Telfon</th>
                                        <th className="py-2 px-4 border-b">Email</th>
                                        <th className="py-2 px-4 border-b">Alamat</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {anggota.map((item) => (
                                        <tr key={item.id} className="hover:bg-gray-100">
                                            <td className="py-2 px-4 border-b whitespace-nowrap">{item.name}</td>
                                            <td className="py-2 px-4 border-b whitespace-nowrap">{item.position}</td>
                                            <td className="py-2 px-4 border-b whitespace-nowrap">{item.nip}</td>
                                            <td className="py-2 px-4 border-b whitespace-nowrap">{item.phoneNumber}</td>
                                            <td className="py-2 px-4 border-b whitespace-nowrap">{item.email}</td>
                                            <td className="py-2 px-4 border-b whitespace-nowrap">{item.address}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default PegawaiContent;